import React, { useEffect, useRef, useState } from 'react';
import '../../Static/Master/PackPrintStruct.css';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchUserReturnData } from '../../Store/PHPSlice/Return';
import { selectUserSaledata } from '../Selectors/Master/OutwardSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectFirm } from '../Selectors/Master/ItemSelectors';


const UserReturnPrint = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    // console.log(userdata)
    const { Id } = useParams();
    const dispatch = useDispatch();
    const componentRef = useRef();
    const [formData, setFormData] = useState({
        ID: '',
        ac_no: '',
        age: '',
        balamt: '',
        bankNm: '',
        branchNm: '',
        cgst: '',
        div: '',
        dt: '',
        fGST: '',
        fadrs: '',
        firmId: '',
        firmNm: '',
        fph: '',
        freight_ch: '',
        gst: '',
        gst_val: '',
        ifsc: '',
        igst: '',
        memo: '',
        netamt: '',
        other_ch: '',
        studph: '',
        schlId: '',
        schlNm: '',
        schlcd: '',
        sgst: '',
        std: '',
        sts: '',
        studId: '',
        studNm: '',
        totamt: '',
        totqty: '',
        sgstper: '',
        cgstper: '',
        igstper: '',
        paidamt: '',
        payableamt: '',
        balamt2: '',
        paymode: ''
    })
    const [packInfo, setPackInfo] = useState([]);
    const [selectFirmdata, setSelectFirmdata] = useState({});
    const [packData, setPackData] = useState([]);
    // const packData = useSelector(selectUserSaledata);
    const firmlist = useSelector(selectFirm);
    console.log(packData)
    useEffect(() => {
        const data = {
            usId: Id
        };
        dispatch(fetchUserReturnData(data))
            .unwrap()
            .then((result) => {
                // Handle success
                // console.log('POST request successful!', result);
                setPackData(result);

            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

        dispatch(fetchCompanyData());
    }, [Id, dispatch]);


    useEffect(() => {
        if (packData?.data) {
            const item = packData?.data[0];

            const {
                ID,
                ac_no,
                age,
                balamt,
                bankNm,
                branchNm,
                cgst,
                div,
                dt,
                DT,
                fGST,
                fadrs,
                firmId,
                firmNm,
                fph,
                freight_ch,
                gst,
                gst_val,
                ifsc,
                igst,
                memo,
                netamt,
                other_ch,
                ph,
                schlId,
                schlNm,
                schlcd,
                sgst,
                std,
                sts,
                studId,
                studNm,
                totamt,
                totqty,
                paidamt,
                payableamt,
                paymode
            } = item;

            const firmdata = firmlist?.data?.find(item => item.ID === '8');
            setSelectFirmdata(firmdata);
            let cgstper, sgstper, igstper = 0;
            if (igst === '0') {
                const halfper = parseFloat(gst_val) / 2;
                cgstper = halfper;
                sgstper = halfper;

            } else {
                igstper = gst_val;
            }
            const balamt2 = parseFloat(payableamt) - parseFloat(paidamt);
            setFormData(prev => ({
                ...prev,
                ID: ID,
                ac_no: ac_no,
                age: age,
                balamt: balamt,
                bankNm: bankNm,
                branchNm: branchNm,
                cgst: cgst,
                div: div,
                dt: DT,
                fGST: fGST,
                fadrs: fadrs,
                firmId: firmId,
                firmNm: firmNm,
                fph: fph,
                freight_ch: freight_ch,
                gst: gst,
                gst_val: gst_val,
                ifsc: ifsc,
                igst: igst,
                memo: memo,
                netamt: netamt,
                other_ch: other_ch,
                ph: ph,
                schlId: schlId,
                schlNm: schlNm,
                schlcd: schlcd,
                sgst: sgst,
                std: std,
                sts: sts,
                studId: studId,
                studNm: studNm,
                totamt: totamt,
                totqty: totqty,
                sgstper: sgstper,
                cgstper: cgstper,
                igstper: igstper,
                paidamt: paidamt,
                payableamt: payableamt,
                balamt2: balamt2,
                paymode: paymode,
                studph: ph
            }));
        }
        if (packData?.info && packData.info?.length > 0) {
            const info = packData.info;
            const totrate = info?.reduce((acc, sum) => acc + parseFloat(sum.disrate), 0);

            setPackInfo(info);
            setFormData(prev => ({
                ...prev,
                totrate: totrate
            }))
        }
    }, [packData]);


    function numberToWords(num) {
        const below20 = [
            'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
            'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
            'Eighteen', 'Nineteen'
        ];
        const tens = [
            '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
        ];
        const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

        if (num === 0) return below20[0];

        let words = '';

        let i = 0;
        while (num > 0) {
            if (num % 1000 !== 0) {
                words = helper(num % 1000) + (thousands[i] ? ' ' + thousands[i] : '') + ' ' + words;
            }
            num = Math.floor(num / 1000);
            i++;
        }

        return words.trim().toUpperCase();

        function helper(n) {
            if (n === 0) return '';
            if (n < 20) return below20[n];
            if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + below20[n % 10] : '');
            return below20[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + helper(n % 100) : '');
        }
    }

    // Example usage:
    // console.log(numberToWords(123)); // Output: "One Hundred Twenty Three"
    // console.log(numberToWords(1234567)); // Output: "One Million Two Hundred Thirty Four Thousand Five Hundred Sixty Seven"
    // console.log(packInfo);


    return (

        <Grid item xs={12}>
            <Paper>
                <div ref={componentRef} style={{ padding: '1%' }}>
                    {/* Heading */}
                    <h3 className="heading">Transfer Invoice Bill</h3>

                    {/* Upper part: Two tables side by side */}
                    <div className="flex-container">
                        {/* Left Table */}
                        <table>
                            <tbody>
                                <tr>
                                    <td><h2>{formData?.studNm}</h2>
                                        <b>School Name:</b>
                                        {formData?.schlNm} 
                                        <br />
                                        <b>School Code:</b>
                                        {formData?.schlcd} 
                                         <br />
                                        </td>
                                </tr>
                                <tr>
                                    <td><h3>TO:</h3>
                                        {/* <b>Firm Name:</b><b style={{ color: 'blue' }}>{formData.firmNm} </b> <br />
                                        <b>Std:</b> <span style={{ color: 'blue' }}>{formData.std}</span><br />
                                        <b>Div:</b> <span style={{ color: 'blue' }}>{formData.div}</span><br />
                                        <b>Contact:</b> <span style={{ color: 'blue' }}>{formData.studph}</span><br />
                                        <b>School Code:</b><b style={{ color: 'blue' }}>{formData.schlcd} </b> <br /> */
                                        
                                            }
                                        <h2>{formData?.firmNm}</h2>
                                        <b>Add.:</b>
                                        {formData?.fadrs}
                                        <br />
                                        <b>Contact:</b>
                                        {formData?.fph}
                                         <br />
                                        <b>GST No.:</b> 
                                        {formData?.fGST}
                                    </td>
                                </tr>

                            </tbody>
                        </table>

                        {/* Right Table */}
                        <table>

                            <tbody>

                                <tr>
                                    <td>Transfer Memo No:</td>
                                    <td><b>{formData.memo}</b></td>
                                </tr>
                                <tr>
                                    <td>Date:</td>
                                    <td>{formData.dt}</td>
                                </tr>
                                <tr>
                                    <td>Transport:</td>
                                    <td>{formData.trspt}</td>
                                </tr>
                                <tr>
                                    <td>Remark:</td>
                                    <td>{formData.remark}</td>
                                </tr>
                                {/* <tr>
                                    <td>No. of Cartoons:</td>
                                    <td>{formData.parcelqty}</td>
                                </tr> */}
                                <tr>
                                    <td>Ship To:</td>
                                    <td>{formData.shtoNm}</td>
                                </tr>
                                <tr>
                                    <td>Ship Address:</td>
                                    <td>{formData.shtoadrs}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                    {/* Main Table */}
                    {packInfo.length > 0 &&

                        <table className="main-table" >
                            <thead>
                                <tr>
                                    <th>SR NO.</th>
                                    <th>PARTICULARS</th>
                                    <th>SIZE</th>
                                    <th>QTY</th>
                                    <th>RATE</th>
                                    <th>AMOUNT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {packInfo.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.itemNm}</td>
                                        <td>{item.size}</td>
                                        <td>{item.qty}</td>
                                        <td>{Math.round(item.disrate)}</td>
                                        <td>{Math.round(item.disamt)}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td><b>Total</b></td>
                                    <td><b>{formData.totqty}</b></td>
                                    <td><b>{formData.totrate}</b></td>
                                    <td><b>{formData.totamt}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    }

                    {/* Footer */}
                    <div className="flex-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>AMOUNT IN WORDS:
                                        <b>{numberToWords(parseFloat(formData.netamt))}</b>
                                    </td>


                                </tr>
                                <tr>
                                    <td>TOTAL QTY: <b> {formData.totqty}</b></td>
                                </tr>


                                {/* <tr>
                                    <td>Bank Name: <b> {selectFirmdata?.bankNm}</b></td>

                                </tr>
                                <tr>
                                    <td>Account No.: <b> {selectFirmdata?.ac_no}</b></td>
                                </tr>

                                <tr>
                                    <td>IFSC code: <b> {selectFirmdata?.ifsc}</b></td>
                                </tr>

                                <tr>
                                    <td>Branch Name: <b> {selectFirmdata?.branchNm}</b></td>
                                </tr> */}

                            </tbody>
                        </table>

                        <table>

                            <tbody>

                                <tr>
                                    <td><b>SUB TOTAL :</b></td>
                                    <td><b>{formData.totamt}</b></td>
                                </tr>
                                {/* <tr>
                                    <td><b>DISCOUNT AMOUNT ({formData.discnt_val}{formData.discnt_type}) :</b></td>
                                    <td><b>{formData.discnt_amt}</b></td>
                                </tr> */}
                                {formData.cgst !== '0' &&
                                    <tr>

                                        <td><b>CGST({formData.cgstper}%)</b></td>
                                        <td>
                                            <b>{formData.cgst}</b>
                                        </td>
                                    </tr>}
                                {formData.sgst !== '0' && <tr>

                                    <td><b>SGST({formData.sgstper}%)</b></td>
                                    <td>
                                        <b>{formData.sgst}</b>
                                    </td>
                                </tr>}

                                {formData.igst !== '0' && <tr>

                                    <td><b>IGST({formData.igstper}%)</b></td>
                                    <td>
                                        <b>{formData.igst}</b>
                                    </td>
                                </tr>}


                                {formData.freight_ch !== '0' && <tr>

                                    <td><b style={{ color: 'red' }}>FREIGHT</b></td>
                                    <td>
                                        <b style={{ color: 'red' }}>{formData.freight_ch}</b>
                                    </td>
                                </tr>}

                                {formData.other_ch !== '0' && <tr>

                                    <td><b>OTHERS</b></td>
                                    <td>
                                        <b>{formData.other_ch}</b>
                                    </td>
                                </tr>}

                                <tr>

                                    <td><b style={{ color: 'blue' }}>GRAND TOTAL</b></td>
                                    <td>
                                        <b style={{ color: 'blue' }}>{formData.netamt}</b>
                                    </td>
                                </tr>

                                <tr>
                                    <td><b style={{ color: 'blue' }}>Paid Amt.</b></td>
                                    <td>
                                        <b style={{ color: 'blue' }}>{formData.paidamt}</b>
                                    </td>
                                </tr>

                                <tr>
                                    <td><b style={{ color: formData.balamt2 > 0 ? 'red' : 'green' }}>Balance Amt.</b></td>
                                    <td>
                                        <b style={{ color: formData.balamt2 > 0 ? 'red' : 'green' }}>{formData.balamt2}</b>
                                    </td>
                                </tr>

                                <tr>
                                    <td><b>Payment Mode</b></td>
                                    <td>
                                        <b>{formData.paymode}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div style={{ margin: '2% 5%' }}>
                    <ReactToPrint
                        trigger={() => <Button variant="contained" color="primary">Print</Button>}
                        content={() => componentRef.current}
                    />
                </div>
            </Paper>
        </Grid >
    );
};

export default UserReturnPrint;
